var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYandexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 12C0.0390625 5.3724 5.41026 0 12.0391 0C18.6655 0 24.0391 5.3724 24.0391 12C24.0391 18.6276 18.6655 24 12.0391 24C5.41026 24 0.0390625 18.6276 0.0390625 12Z",
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5741 6.79829H12.4653C10.4325 6.79829 9.36333 7.82789 9.36333 9.34589C9.36333 11.0619 10.1025 11.8659 11.6205 12.8967L12.8745 13.7415L9.27093 19.1259H6.57812L9.81213 14.3091C7.95213 12.9759 6.90813 11.6811 6.90813 9.49109C6.90813 6.74549 8.82213 4.87109 12.4521 4.87109H16.0557V19.1127H13.5741V6.79829Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexLogo);
export default __webpack_public_path__ + "static/media/YandexLogo.d148f3660975529b595c2fc5cf33b67b.svg";
export { ForwardRef as ReactComponent };